import { render, staticRenderFns } from "./DataAdministrationAccountRequestLists.vue?vue&type=template&id=233a7334&scoped=true"
import script from "./DataAdministrationAccountRequestLists.vue?vue&type=script&lang=js"
export * from "./DataAdministrationAccountRequestLists.vue?vue&type=script&lang=js"
import style0 from "./DataAdministrationAccountRequestLists.vue?vue&type=style&index=0&id=233a7334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a7334",
  null
  
)

export default component.exports